import { render } from "./AdDetailsBox.vue?vue&type=template&id=4dc3daa4&scoped=true"
import script from "./AdDetailsBox.vue?vue&type=script&lang=js"
export * from "./AdDetailsBox.vue?vue&type=script&lang=js"

import "./AdDetailsBox.vue?vue&type=style&index=0&id=4dc3daa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc3daa4"]])

export default __exports__